module.exports = __webpack_public_path__ + "img/map_bk.a72a5c7a.png";